import {
    UPDATE_PINCH_IN_IMAGE_ZOOMED,
    UPDATE_DOUBLE_CLICK_IMAGE_ZOOMED,
    RESET_IMAGE_ZOOM_STATUS,
} from '../actionTypes/PdpImageZoomActionType';

const initialState = {
    isPinchinZoomed: false,
    isDoubleclickZoomed: false,
};

function PdpImageZoomReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_PINCH_IN_IMAGE_ZOOMED:
            return { ...state, isPinchinZoomed: action?.payload };
        case UPDATE_DOUBLE_CLICK_IMAGE_ZOOMED:
            return { ...state, isDoubleclickZoomed: action?.payload };
        case RESET_IMAGE_ZOOM_STATUS:
            return {
                ...state,
                isDoubleclickZoomed: action?.payload,
                isPinchinZoomed: action?.payload,
            };

        default:
            return state;
    }
}

export default PdpImageZoomReducer;
